import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import { EDefaultFilterValues, ISelectedFilterTemplateId, IEmployeeReportColumns, ECustomReportLocation, ICustomReportDocument, INewCustomReportParameters, IUserFilter, IEmployeesReportParameters } from "../../models"
import * as api from "../../api"
import AppStateStore from "../../stores/AppStateStore"
import * as reportAction from "../../actions/ReportAction"
import AccountStore from "../../stores/AccountStore"
import AuthenticationStore from "../../stores/AuthenticationStore"

interface IProps {
    total: number
    employeeColumns: IEmployeeReportColumns
    selectedFilterTemplateId: ISelectedFilterTemplateId
    getUserFilterData(): IUserFilter
}
interface IState {
    newReports: ICustomReportDocument[]
}

export default class UsersReport extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            newReports: []
        }
    }

    componentDidMount() {
        this.getNewReportTypes()
    }

    getNewReportTypes() {
        api.getCustomReportTypes(ECustomReportLocation.EmployeePage).then(res =>
            this.setState({ newReports: res.data })
        )
    }

    render() {
        return (
            <div style={{ marginTop: -10, marginLeft: 5 }}>
                <IconMenu
                    style={{ padding: 0 }}
                    iconButtonElement={
                        <IconButton data-intercom-target={"Employee-Page-Report"} tooltip={strings.Reports}>
                            <FontIcon className="fa fa-file-text itemActionButton" style={{ fontSize: 20 }} />
                        </IconButton>
                    }
                >
                    <MenuItem
                        data-intercom-target={"Employee-Page-Report-Download"}
                        primaryText={strings.Download}
                        leftIcon={<FontIcon className="fa fa-download" />}
                        onTouchTap={() => {
                            const employeeReportParams = {
                                Page: 0,
                                Limit: this.props.total,
                                UserFilter: this.props.getUserFilterData(),
                                ReportColumns: this.props.employeeColumns
                            } as IEmployeesReportParameters
                            this.props.selectedFilterTemplateId !== EDefaultFilterValues.CREATE_NEW &&
                                reportAction.downloadUsersData(AccountStore.getCurrentAccount().Id, employeeReportParams)
                        }}
                    />
                    {this.state.newReports.map(i =>
                        <MenuItem
                            key={i.Id}
                            data-intercom-target={"Employee-Page-Btn-CustomReport"}
                            primaryText={i.Name}
                            leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                            onTouchTap={() => AppStateStore.setNewCustomReportDialogContent({
                                newCustomReportDoc: i,
                                newCustomReportParameters: {
                                    CallingUserId: AuthenticationStore.getLoggedInUser().Id,
                                    UserFilter: this.props.getUserFilterData()
                                } as INewCustomReportParameters
                            })}
                        />
                    )}
                </IconMenu>
            </div>
        )
    }
}